import { connect } from 'react-redux';
import { EditEquipmentComponent } from './edit-equipment.component';
import { AppState } from '../../app.state';
import { updateMyEquipment } from '../dashboard.actions';

export const EditEquipment = connect(
  (sState: AppState) => ({ sState }),
  {
    updateMyEquipment,
  }
)(EditEquipmentComponent as any) as unknown as typeof EditEquipmentComponent;
